import { BadgeCheck } from "lucide-react";
import { useI18n } from "../lib/i18n";

/** Professional approval follows identity approval, so one badge represents both. */
export function ProfessionalBadges({ professions }: { professions: readonly string[]; compact?: boolean }) {
  const { t } = useI18n();
  if (professions.length === 0) return null;
  const label = t("profile.identityProfessionalVerified", "Verified Identity & Professional");
  return <span
    role="img"
    aria-label={`${label}: ${professions.join(", ")}`}
    title={label}
    className="inline-flex h-4 w-4 shrink-0 items-center justify-center">
    <BadgeCheck className="h-4 w-4 fill-sky-100 text-sky-700" aria-hidden="true" />
  </span>;
}
